var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutubeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4177 6.955c-.1287-.51414-.3908-.98521-.7598-1.36564-.3691-.38043-.8319-.65674-1.3419-.80102-1.8633-.455-9.3167-.455-9.3167-.455s-7.45332 0-9.31665.49833c-.50998.14428-.97286.42059-1.34187.80102-.36902.38043-.63111.85151-.7598 1.36565-.34101 1.89101-.50782 3.80936-.49833 5.73086-.01216 1.9359.15467 3.8689.49833 5.7741.14188.4982.40984.9514.77799 1.3157.36816.3644.82407.6276 1.32368.7643 1.86333.4984 9.31665.4984 9.31665.4984s7.4534 0 9.3167-.4984c.51-.1442.9728-.4206 1.3419-.801.369-.3804.6311-.8515.7598-1.3656.3383-1.8768.5051-3.7805.4983-5.6875.0121-1.936-.1547-3.86894-.4983-5.7742z",
    stroke: "#fff",
    strokeWidth: 2.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5618 16.2717l6.2292-3.5425-6.2292-3.54253v7.08503z",
    stroke: "#fff",
    strokeWidth: 2.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube_icon.9a607fafa70ced5dc5558f18a45980af.svg";
export { ForwardRef as ReactComponent };